import React, { useEffect, useRef, useState } from 'react';
import { Container, Form, Header, Icon, Breadcrumb, Button, Grid, Radio, Table, Message, Dropdown } from 'semantic-ui-react';
import { Link, useParams } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router';
import { useEditWorkshopForm } from './useEditWorkshop';
import { RegisteredJobSeekers } from './RegisteredJobSeekers';
import { useRegisteredJobSeekers } from './useRegisteredJobSeekers';
import { convertToRaw } from 'draft-js';
import CommonRichEditor from '../../Common/CommonComponents/CommonRichEditor';
import moment from 'moment';
import Swal from 'sweetalert2';
import { sendForgetPasswordEmail } from '../../../Services/LoginServices';
import NewCommonRichEditor from '../../Common/CommonComponents/NewCommonRichEditor';

export function EditWorkshopForm() {
    let { WId } = useParams<{ WId: string }>();
    
    let [values, masterData, errors, touched, isLoading, isSubmitting, isValid, submitSuccess, errorMessage, dataLoaded,
        registerRef, handleChange, handleBlur, handleSubmit, handleDelete, handleSendEmail] = useEditWorkshopForm();
    
    let [listData, isListLoading, handleDeleteJobSeeker, handleExport] = useRegisteredJobSeekers(parseInt(WId));

    const [isPast, setIsPast] = useState<boolean>(false);
    const prevDate = useRef<string|null>(null);
    const history = useHistory();
    const today = moment().format('yyyy-MM-DD');

    function handleBackToList() {
        history.push('/workshopList');
    }
    
    const isEdit: boolean = WId != '0';
    const allowDeleteWorkshop: boolean = !isListLoading && listData.length == 0;
    
    useEffect(() => {
        
        if(prevDate.current !== values.workshopDate){
            let lastValue = prevDate.current;
            prevDate.current = values.workshopDate;
            // which means date changed.
            if (isEdit && values.workshopDate && moment().isAfter(moment(values.workshopDate), 'day') && isPast !== true) {
                if(lastValue === '' && values.workshopDate !== ''){
                    setIsPast(true);
                }
            }

        }
        
    }, [values.workshopDate]);

    




    function onDeleteJobSeeker(jobseekerId: number){
        Swal.fire({
            title: 'Confirm Deletion',
            text: "Would you like to delete this job seeker?",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonColor: 'lightgray',
            confirmButtonText: 'Delete',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                handleDeleteJobSeeker(jobseekerId);
            }
        })
    }

    
    
    
    function onDeleteWorkshop(){
        if(allowDeleteWorkshop){
            handleDelete();
        }else {
            Swal.fire({
                title: 'Unable to delete',
                text: `You will not be able to delete this workshop at this time because there ${listData.length > 1? 'are': 'is'} ${listData.length} job seeker${listData.length > 1? 's have': ' who has'} been registered for this workshop.  First, you will have to remove ${listData.length > 1? 'these': 'this'} job seekers from the registration list to be able to delete this workshop.`,
                icon: 'info',
                showCancelButton: true,
                showConfirmButton: false,
                cancelButtonText: 'OK',
            });  
        }
    }

    function onSendEmail(){
        if(listData.length > 0){
            Swal.fire({
                title: 'Confirm Sending Notifications',
                text: `You are about to send an email to ${listData.length > 1 ? 'all '+ listData.length + ' job seekers':'the job seeker'} registered for this workshop. Do you want to continue?`,
                icon: 'warning',
                showCancelButton: true,
                cancelButtonColor: 'lightgray',
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel',
            }).then((result) => {
                if (result.isConfirmed) {
                    handleSendEmail();
                }
            })
        }else {
            Swal.fire({
                title: 'No one registered',
                text: `There is no job seeker to send email to.`,
                icon: 'info',
                showCancelButton: true,
                showConfirmButton: false,
                cancelButtonText: 'OK',
            });  
        }
        
    }

    return <Container className='providers-container'>
        <Header as='h1' style={{ marginTop: '2.0rem', marginBottom: '0.5rem' }}>{isEdit ? 'Edit' : 'Create'} Job Seeker Workshop</Header>
        <hr style={{ marginBottom: '1.0rem' }} />
        <Breadcrumb style={{ marginBottom: '1.0rem' }}>
            <Breadcrumb.Section link><Link to='/'>Home</Link></Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section link><Link to={'/workshopList'}>Job Seeker Workshops</Link></Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section active>{isEdit ? 'Edit' : 'Create'} Job Seeker Workshop</Breadcrumb.Section>
        </Breadcrumb>

        <Grid columns={2} style={submitSuccess ? { margin: 0 } : {}}>
            {
                !submitSuccess && !isPast &&
                <Grid.Column>
                    <Form loading={isSubmitting || !dataLoaded}>
                        <Form.Field required
                            error={!(!errors.workshopTypeId || !touched.workshopTypeId) ? true : false}
                            className={!(!errors.workshopTypeId || !touched.workshopTypeId) ? 'mb-0' : ''}>
                            <label>Workshop Type</label>
                            <Dropdown
                                placeholder='Select Workshop Type'
                                fluid
                                closeOnChange={true}
                                search
                                clearable
                                selection
                                selectOnBlur={false}
                                value={values.workshopTypeId}
                                options={(masterData || []).map((item, index) => { return { value: item.id, text: item.displayName } })}
                                onChange={(event, data) => {
                                    let newValue = (data as { value: any }).value;
                                    handleChange(newValue, 'workshopTypeId');
                                }}
                                onClose={
                                    () => { handleBlur('workshopTypeId') }
                                }
                                error={!(!errors.workshopTypeId || !touched.workshopTypeId) ? true : false}
                            />
                            {
                                !(!errors.workshopTypeId || !touched.workshopTypeId) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.workshopTypeId}</div>
                            }
                        </Form.Field>
                        <Form.Input className={!(!errors.workshopDate || !touched.workshopDate) ? 'mb-0' : ''}
                            fluid
                            type='date'
                            label='Workshop Date'
                            placeholder='mm/dd/yyyy'
                            required
                            min={today}
                            value={values.workshopDate}
                            onChange={(event, data) => {
                                handleChange(data.value, 'workshopDate');
                            }}
                            onBlur={
                                () => { handleBlur('workshopDate') }
                            }
                            error={!(!errors.workshopDate || !touched.workshopDate) ? true : false}
                        />
                        {
                            !(!errors.workshopDate || !touched.workshopDate) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.workshopDate}</div>
                        }

                        <Form.Input className={!(!errors.startDate || !touched.startDate) ? 'mb-0' : ''}
                            required
                            fluid
                            label='Start Time'
                            onChange={(event, data) => {
                                handleChange(data.value, 'startDate');
                            }}
                            onBlur={
                                () => { handleBlur('startDate') }
                            }
                            placeholder='HH:MM AM/PM'
                            value={values.startDate}
                            error={!(!errors.startDate || !touched.startDate) ? true : false}
                        />
                        {
                            !(!errors.startDate || !touched.startDate) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.startDate}</div>
                        }

                        <Form.Input className={!(!errors.endDate || !touched.endDate) ? 'mb-0' : ''}
                            required
                            fluid
                            label='End Time'
                            placeholder='HH:MM AM/PM'
                            onChange={(event, data) => {
                                handleChange(data.value, 'endDate');
                            }}
                            onBlur={
                                () => { handleBlur('endDate') }
                            }
                            value={values.endDate}
                            error={!(!errors.endDate || !touched.endDate) ? true : false}
                        />
                        {
                            !(!errors.endDate || !touched.endDate) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.endDate}</div>
                        }
                        <Form.Group inline className={!(!errors.workshopMode || !touched.workshopMode) ? 'mb-0' : ''}>
                            <label>Workshop Mode<span style={{ color: '#db2828', margin: '-0.2em 0 0 0.2em' }}>*</span></label>
                            <Form.Field
                                control={Radio}
                                label={"Online"}
                                value={'Online'}
                                checked={values.workshopMode == 'Online'}
                                onChange={(event: any, data: any) => {
                                    let newValue = (data as { value: any }).value;
                                    handleChange(newValue, 'workshopMode', false);
                                }}
                                error={!(!errors.workshopMode || !touched.workshopMode) ? true : false}
                            />
                            <Form.Field
                                control={Radio}
                                label={'In Person'}
                                value={'In-Person'}
                                checked={values.workshopMode == 'In-Person'}
                                onChange={(event: any, data: any) => {
                                    let newValue = (data as { value: any }).value;
                                    handleChange(newValue, 'workshopMode', false);
                                }}
                                error={!(!errors.workshopMode || !touched.workshopMode) ? true : false}
                            />
                        </Form.Group>
                        {
                            values.workshopMode == 'In-Person' &&
                            <>
                                <Form.Input className={!(!errors.location || !touched.location) ? 'mb-0' : ''}
                                    label='Location'
                                    required={false}
                                    onChange={(event, data) => {
                                        handleChange(data.value, 'location');
                                    }}
                                    onBlur={
                                        () => { handleBlur('location') }
                                    }
                                    value={values.location}
                                    error={!(!errors.location || !touched.location) ? true : false}
                                />
                                {
                                    !(!errors.location || !touched.location) &&
                                    <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.location}</div>
                                }

                                <Form.Input className={!(!errors.roomNumber || !touched.roomNumber) ? 'mb-0' : ''}
                                    label='Room Number'
                                    required={false}
                                    onChange={(event, data) => {
                                        handleChange(data.value, 'roomNumber');
                                    }}
                                    onBlur={
                                        () => { handleBlur('roomNumber') }
                                    }
                                    value={values.roomNumber}
                                    error={!(!errors.roomNumber || !touched.roomNumber) ? true : false}
                                />
                                {
                                    !(!errors.roomNumber || !touched.roomNumber) &&
                                    <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.roomNumber}</div>
                                }
                            </>
                        }
                        {
                            values.workshopMode == 'Online' &&
                            <Form.Field style={{width:'202%'}}>
                                <label>Meeting Information</label>
                                <NewCommonRichEditor
                                    
                                    value={values.meetingInformation || ''}
                                    onChange={(rawContent: any) => {
                                        handleChange(rawContent, 'meetingInformation');
                                    }}
                                    onBlur = {()=>{
                                        handleBlur('meetingInformation');
                                    }}
                                />
                            </Form.Field>
                        }
                        <Button type='button' loading={isSubmitting} primary onClick={handleSubmit}>Save</Button>
                        {
                            isEdit && !isPast &&
                            <Button type='button' loading={isSubmitting} color='red' onClick={onDeleteWorkshop}>Delete</Button>
                        }
                        
                        <Button type='button' onClick={() => { history.goBack() }}>Cancel</Button>
                    </Form>
                </Grid.Column>
            }
            {
                isPast &&
                <Grid.Column>
                    <Table padded striped style={{ marginTop: '1.0rem' }}>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell width={4}><b>Workshop Type</b></Table.Cell>
                                <Table.Cell>{values.workshopTypeId}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}><b>Workshop Date</b></Table.Cell>
                                <Table.Cell>{moment(values.workshopDate).format('MM/DD/YYYY')}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}><b>Start Time</b></Table.Cell>
                                <Table.Cell>{values.startDate}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}><b>End Time</b></Table.Cell>
                                <Table.Cell>{values.endDate}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}><b>Workshop Mode</b></Table.Cell>
                                <Table.Cell>{values.workshopMode}</Table.Cell>
                            </Table.Row>
                            {
                                values.workshopMode == 'Online' &&
                                <Table.Row>
                                    <Table.Cell width={4}><b>Meeting Information</b></Table.Cell>
                                    <Table.Cell><div dangerouslySetInnerHTML={{__html:values.meetingInformation}}></div></Table.Cell>
                                </Table.Row>
                            }
                            {
                                values.workshopMode == 'In-Person' &&
                                <>
                                    <Table.Row>
                                        <Table.Cell width={4}><b>Location</b></Table.Cell>
                                        <Table.Cell>{values.location}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell width={4}><b>Room Number</b></Table.Cell>
                                        <Table.Cell>{values.roomNumber}</Table.Cell>
                                    </Table.Row>
                                </>
                            }
                        </Table.Body>
                    </Table>
                    <Button type='button' onClick={() => { history.goBack() }}>Back</Button>
                </Grid.Column>
            }
            {
                submitSuccess &&
                <Message icon positive>
                    <Icon name='check circle outline' color='green' />
                    <Message.Content>
                        <Message.Header>Success</Message.Header>
                        {
                            isEdit &&
                            <div>Thank you for editing a workshop. This workshop has been updated.</div>
                        }
                        {
                            !isEdit &&
                            <div>Thank you for creating a workshop. This workshop has been created.</div>
                        }
                        <div style={{ marginTop: '0.5rem' }}>
                            <Button icon labelPosition='left' size='small' onClick={handleBackToList}>
                                <Icon name='arrow circle left' />
                                <span>Back to Job Seeker Workshops</span>
                            </Button>
                            <Button type='button' loading={isLoading} color='green' onClick={onSendEmail}>Send an email to job seekers</Button>
                            </div>
                    </Message.Content>
                </Message>
            }
            <Grid.Column>
                {
                    isEdit &&
                    <RegisteredJobSeekers
                        disabled = {isPast || submitSuccess}
                        listData={listData}
                        handleDelete={onDeleteJobSeeker}
                        handleExport={()=>{handleExport(parseInt(WId))}}
                        isListLoading = {isListLoading}
                        limitedHeight = {submitSuccess|| isPast ? false : true}
                    ></RegisteredJobSeekers>
                }
            </Grid.Column>

        </Grid>

    </Container>
}